module.exports = __webpack_public_path__ + "assets/img/c22.c4e6efb2.png";